<template>
	<section v-loading="loadingDM">
		<div class="d-flex mt-3 mb-3 flex-row-reverse">
			<el-popover placement="bottom" width="300" trigger="click">
				<el-checkbox-group v-model="fieldsShow">
					<el-checkbox :key="index" v-for="(key, index) in fields" :label="key.name">{{
						ItemDM[key.name].show_name
					}}</el-checkbox>
				</el-checkbox-group>
				<el-button icon="el-icon-view" circle size="mini" slot="reference"></el-button>
			</el-popover>
		</div>
		<el-table
			:data="items"
			style="width: 100%;"
			v-loading="loadings.main"
			@sort-change="handleSortChange"
			size="small"
			:show-summary="showSummary"
			border

			@selection-change="handleSelectionChange"
		>
			<el-table-column type="expand" v-if="beExpandFields.length > 0">
				<template slot-scope="props">
					<el-form label-position="left" label-width="120px" inline class="expand">
						<el-form-item
							:label="ItemDM[key.name].show_name"
							:key="index"
							v-for="(key, index) in beExpandFields"
						>
							<field-show
								:field-info="ItemDM[key.name]"
								:value="props.row[key.name]"
								:field-key="key"
							></field-show>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column
				:prop="key.name"
				:label="ItemDM[key.name].show_name"
				:sortable="key.sortable"
				:key="index"
				:width="key.width"
				v-for="(key, index) in realFields"
			>
				<div slot-scope="scope">
					<field-show
						:field-info="ItemDM[key.name]"
						:value="scope.row[key.name]"
						:field-key="key"
						:tooltip-img="key.needThumb ? scope.row[key.needThumb] : ''"
						:params="key.params"
						v-if="!key.render"
					></field-show>
					<span v-else v-html="key.render(scope.row)"></span>
				</div>
			</el-table-column>
			<el-table-column label="分仓库存" v-if="userPrivilegeMapping[53]">
				<template slot-scope="scope">
					<div class="text-right">
						<div
							v-for="(amount, warehouseId) in scope.row.amount_warehouse"
							:key="warehouseId"
						>
							<div
								v-if="
									warehouseFilter._id == '' || warehouseFilter._id == warehouseId
								"
							>
								{{ warehousesMapping[warehouseId].name }}:
								<span class="text-semi font-black">{{ amount }}</span>
							</div>
						</div>
					</div>
					<!-- <div v-else>暂无数据 {{item_warehouse_mapping}} {{scope.row._id}}</div> -->
				</template>
			</el-table-column>
		</el-table>


		<div class="row" v-if="hasPage">
			<div class="col-lg-12 mt-3">
				<el-pagination
					layout="total,prev, pager, next, jumper"
					:total="paginations.main.total"
					:page-size="50"
					:current-page="paginations.main.pageNow"
					background
					@current-change="handlePageChange"
				></el-pagination>
			</div>
		</div>
	</section>
</template>

<script>
import CurdTable from "@/mixins/CurdTable.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import ItemDM from "@/datamodels/Item";
import { RenderPrice } from "@/mixinsApp/Render.js";

export default {
	mixins: [CurdTable],
	config: {
		ItemDM,
	},
	data() {
		return {
      is_check : 0,
			items: [],
			beExpandFields: [
				{
					name: "brand_show_id",
					sortable: "custom",
				},
				{
					name: "color_code",
					sortable: "custom",
				},
				{
					name: "classify",
					sortable: "custom",
				},
				{
					name: "price_0",
					sortable: "custom",
				},
				{
					name: "price_1",
					sortable: "custom",
					render: (info) => {
						return RenderPrice(info, "price_1");
					},
				},
				{
					name: "price_2",
					sortable: "custom",
					render: (info) => {
						return RenderPrice(info, "price_2");
					},
				},
				{
					name: "price_3",
					sortable: "custom",
					render: (info) => {
						return RenderPrice(info, "price_3");
					},
				},
				{
					name: "is_special",
				},
				{
					name: "thumb_img",
				},
			],
			fields: [
				{
					name: "show_id",
					sortable: "custom",
					needThumb: "thumb_img",
					params: {
						width: "120px",
					},
				},
				{
					name: "brand",
					sortable: "custom",
				},
				{
					name: "product_color",
					sortable: "custom",
					params: {
						width: "150px",
					},
				},
				{
					name: "color_name",
					sortable: "custom",
					params: {
						width: "3rem",
					},
				},
				{
					name: "model",
					sortable: "custom",
					params: {
						width: "3rem",
					},
				},
        {
          name: "contrast",
          sortable: "custom",
          params: {
            isRight: true,
            isBold: true,
            isZeroSlash: true,
          },
          privilege: [53],
        },

				{
					name: "amount",
					sortable: "custom",
					params: {
						isRight: true,
						isBold: true,
						isZeroSlash: true,
					},
					privilege: [53],
				},

			],
		};
	},
	props: {
    warehouseTable:{
      type:String,
      default:'',
    },
		warehouseFilter: {
			type: Object,
			default: function () {
				return {
					_id: "",
				};
			},
		},
	},
	computed: {
		...mapState(["warehousesMapping", "userPrivilegeMapping"]),
		realFields() {
			let fieldShowFilter = {};
			this.fieldsShow.forEach((val) => {
				fieldShowFilter[val] = 1;
			});
			return this.fields.filter((key) => {
				if (key.privilege) {
					let orHavePri = false;
					key.privilege.forEach((pri) => {
						if (this.userPrivilegeMapping[pri]) {
							orHavePri = true;
						}
					});

					if (!orHavePri) {
						return false;
					}
				}

				if (!fieldShowFilter[key.name]) {
					return false;
				}
				return true;
			});
		},
		viewModels() {
			let models = {};
			for (let k in this.viewFields) {
				let val = this.viewFields[k];
				if (!val.table) {
					val.table = this.dataModel;
				}
				if (this.dataModels[val.table]) {
					models[val.name] = this.dataModels[val.table][val.name];
				}
			}

			return models;
		},
	},
	methods: {
		calcWarehouseName(id) {
			return this.warehousesMapping[id].name;
		},
    //筛选
    refreshTable(){
      this.is_check = 1;
      this.loadings.main = true;
      const url = '/inventory/list_all_stocks_contrast/';
      this.$axios
          .post(url, {
            page: this.hasPage ? this.paginations.main.pageNow : -999,
            sortKey: this.sorts.sortKey,
            sortOrder: this.sorts.sortOrder,
            searchFilter: this.searchFilter,
            dateFilter: this.dateFilter,
            kvFilter: this.kvFilter,
            warehouseFilter: this.warehouseFilter._id,
            is_check : this.is_check,
          })
          .then((json) => {
            this.filterWaretable=''
            this.loadings.main = false;
            this.items = json.data.datas;
            this.setPageTotal(json.data.pages.total);
            this.hasGetData = true;
          })
          .catch((json) => {
            this.loadings.main = false;
          });
    },
    //输入框
		refreshData() {
			this.loadings.main = true;
			const url = '/inventory/list_all_stocks_contrast/';
			this.$axios
				.post(url, {
					page: this.hasPage ? this.paginations.main.pageNow : -999,
					sortKey: this.sorts.sortKey,
					sortOrder: this.sorts.sortOrder,
					searchFilter: this.searchFilter,
					dateFilter: this.dateFilter,
					kvFilter: this.kvFilter,
					warehouseFilter: this.warehouseFilter._id,
          is_check : this.is_check,
				})
				.then((json) => {
					this.loadings.main = false;
					this.items = json.data.datas;
					this.setPageTotal(json.data.pages.total);
					this.hasGetData = true;
				})
				.catch((json) => {
					this.loadings.main = false;
				});
		},
	},
	watch: {
    warehouseTable(val){
      this.refreshTable()
    },
		warehouseFilter(val) {
			this.refreshData();

		},
	},
};
</script>
<style lang="scss" scoped>
.expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.cell {
	.el-button {
		margin-bottom: 1em;
	}
}
</style>
